import { FC, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from '@bonusly/design-system';

interface DeleteUserSpotlightSectionModalProps {
	isOpen: boolean;
	onClose: () => void;
	onDelete: () => void;
	isDeleting?: boolean;
	sectionTitle?: string;
}

export const DeleteUserSpotlightSectionModal: FC<DeleteUserSpotlightSectionModalProps> = ({ isOpen, onClose, onDelete, isDeleting = false, sectionTitle }) => {
	const { t } = useTranslation('spotlight');
	const cancelRef = useRef<HTMLButtonElement>(null);

	return (
		<AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose} isCentered>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">
						{t('deleteSectionModal.title')}
					</AlertDialogHeader>

					<AlertDialogBody>
						{sectionTitle ? <Trans i18nKey="deleteSectionModal.bodyWithTitle" ns="spotlight" values={{ title: sectionTitle }} /> : t('deleteSectionModal.body')}
					</AlertDialogBody>

					<AlertDialogFooter>
						<Button ref={cancelRef} onClick={onClose} variant="ghost" colorScheme="secondary" isDisabled={isDeleting}>
							{t('deleteSectionModal.cancel')}
						</Button>
						<Button colorScheme="danger" onClick={onDelete} ml={3} isLoading={isDeleting}>
							{t('deleteSectionModal.remove')}
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};
